import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedDirectivesObserverModule } from '@fantaz/shared/directives/observer';
import { CurrencyModule } from '@fantaz/shared/ui/currency';
import {
  ExpandedCardComponent,
  GameCardModule,
} from '@fantaz/tournaments-v2/ui/game-card';
import { TournamentsCardsViewComponent } from './tournaments-cards-view.component';

@NgModule({
  imports: [
    CommonModule,
    GameCardModule,
    CurrencyModule,
    MatTooltipModule,
    SharedDirectivesObserverModule,
    ExpandedCardComponent,
  ],
  declarations: [TournamentsCardsViewComponent],
  exports: [TournamentsCardsViewComponent],
  providers: [],
})
export class TournamentsCardsViewModule {}
